/**
 * 对象拷贝，参考$.extend()实现。首个参数为true时为深度拷贝，默认为false。
 *
 * @param {any} args
 * @returns
 * @memberof SharedService
 */
export function extend() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // tslint:disable-next-line:one-variable-per-declaration
    var options, src, srcType, copy, copyIsArray, clone, target = args[0] || {}, i = 1, deep = false;
    var length = args.length;
    if (typeof target === 'boolean') {
        deep = target;
        target = args[i] || {};
        i++;
    }
    if (typeof target !== 'object' && typeof target !== 'function') {
        target = {};
    }
    if (i === length) {
        target = this;
        i--;
    }
    for (; i < length; i++) {
        options = args[i];
        if (options !== null) {
            for (var name in options) {
                if (options.hasOwnProperty(name)) {
                    src = target[name];
                    copy = options[name];
                    if (target === copy) {
                        continue;
                    }
                    srcType = Array.isArray(src) ? 'array' : typeof src;
                    copyIsArray = Array.isArray(copy);
                    if (deep && copy && (copyIsArray || typeof copy === 'object')) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && srcType === 'array' ? src : [];
                        }
                        else {
                            clone = src && srcType === 'object' ? src : {};
                        }
                        target[name] = extend(deep, clone, copy);
                    }
                    else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }
    }
    return target;
}
